import getProp from '@f/get-prop'

export function getOauthProvider (state, provider) {
  return getProp(`oauth.${provider}`, state) || {}
}

export function getOauthUserData (state, provider, workspaceId, sourceSlug, integrationSlug) {
  return (getOauthUserRequest(state, provider, workspaceId, sourceSlug, integrationSlug) || {}).data
}

export function getOauthUserRequest (state, provider, workspaceId, sourceSlug, integrationSlug) {
  let oauthKey = `${workspaceId}-${sourceSlug}-${provider}-userdata`
  if (integrationSlug) oauthKey = `${workspaceId}-${sourceSlug}-${integrationSlug}-${provider}-userdata`
  return getProp(`oauth.${oauthKey}`, state)
}

export function getOauthLocalStorageFlags (state) {
  return getProp('oauth.localStorageFlags', state) || {}
}



// WEBPACK FOOTER //
// ./selectors/oauth.js